import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  container: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  paper: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  grid: {
    flexGrow: 1,

    '@media (max-width: 1500px)': {
      '& .ag-header, & .ag-header-container, & .ag-header-cell-text': {
        whiteSpace: 'unset',
      },
    },
  },
});
